import classnames from "classnames"
import PropTypes from "prop-types"
import React from "react"

const ICONS = {
  us_bank_account: "fa-solid fa-building-columns",
  card: "fa-solid fa-credit-card",
  manual: "fa-solid fa-money-bills",
}

const MethodTiles = ({ kinds, selected, onSelect, copy }) => {
  const labels = {
    us_bank_account: copy.methodAch,
    card: copy.methodCard,
    manual: copy.methodCash,
  }

  return (
    <fieldset>
      <legend className="mb-2 border-0 text-sm font-semibold text-gray-900">
        {copy.payVia}
      </legend>
      <div className="grid grid-cols-3 gap-3">
        {kinds.map((kind) => (
          <button
            key={kind}
            type="button"
            aria-pressed={selected === kind}
            onClick={() => onSelect(kind)}
            className={classnames(
              "flex h-20 items-center justify-center gap-2 rounded border px-3 text-sm hover:border-blue-600 hover:bg-blue-50",
              selected === kind
                ? "border-blue-600 bg-blue-50 font-semibold text-blue-700"
                : "border-gray-300 bg-white text-gray-900"
            )}
          >
            <i className={ICONS[kind]} aria-hidden="true" />
            {labels[kind]}
          </button>
        ))}
      </div>
    </fieldset>
  )
}

MethodTiles.propTypes = {
  kinds: PropTypes.arrayOf(
    PropTypes.oneOf(["us_bank_account", "card", "manual"])
  ).isRequired,
  selected: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
  copy: PropTypes.shape({
    payVia: PropTypes.string,
    methodAch: PropTypes.string,
    methodCard: PropTypes.string,
    methodCash: PropTypes.string,
  }).isRequired,
}

export default MethodTiles
